import { styled } from '../../utils/styled'

export const StyledDivLoaderContainer = styled('div')(() => ({
  height: 'fit-content',
  display: 'flex'
}))
